import React, {useState, useEffect} from 'react'
import {Link, useHistory} from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux';
import LogoMark from "../../../images/LogoMark.png"
import "./SetupProfilePage.css"
import { auth, firestore, storage } from '../../../firebase/utils';
import ImagePlaceholder from "../../../images/ImagePlaceholder.png"
import Multiselect from 'multiselect-react-dropdown';
import { AiOutlineCamera } from 'react-icons/ai'
import { Button, Spinner } from 'react-bootstrap';
import GreenHeader from '../../../components/GreenHeader/GreenHeader';


const myStyle={
  backgroundImage: `url(${LogoMark})`,
  backgroundColor: '#016b37',
  height:'200vh',
  marginTop:'-10px',
  fontSize:'50px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const mapState = ({ user }) => ({
currentUser: user.currentUser
});


const SetupProfilePage =()=>{

  // const [skills, setSkill] = useState(["Web Development", "Product Design", "Digital Marketing", "Project Management", "Product Management"])

    const [Img, setImg] = useState("")
    const [placeholder, setPlaceholder] = useState(ImagePlaceholder)
    const [isloading, setLoading] = useState(false);

    const history = useHistory();

    const onImageChange = (e) => {
      const file = e.target.files[0];
      setImg(file);
      setPlaceholder(URL.createObjectURL(file));

    }

    const { currentUser, userErr } = useSelector(mapState);
    const [location, setLocation] = useState(currentUser.location);
    const [skills, setSkills] = useState(currentUser.skills);
    const [firstName, setFirstName] = useState(currentUser.fName);
    const [lastName, setLastName] = useState(currentUser.lName);

    const [plfirstName, setplFirstName] = useState(currentUser.fName);
    const [pllastName, setplLastName] = useState(currentUser.lName);
    const [plskills, setplskills] = useState(currentUser.skills);
    const [pllocation, setpllocation] = useState(currentUser.location);
    const [pldp, setpldp] = useState(currentUser.photoURL);

    useEffect(() => {
      if (currentUser) {
        console.log(currentUser.fName);
        
      }
  
    }, [currentUser]);

    if(plfirstName === undefined){
      setplFirstName("firstName");
    }

    if(pldp === undefined){
      setpldp(ImagePlaceholder);
    }

    if(pllastName === undefined){
      setplLastName("lastName");
    }

    if(pllocation === undefined){
      setpllocation("Location");
    }
    
    if(plskills === undefined){
      setplskills("Skills");
    }

    const updateProfile = async (e) => {
      setLoading(true);
      const promises = [];
      const uploadTask = storage.ref(`images/${currentUser.id}`).put(Img);
      promises.push(uploadTask);
      uploadTask.on(
        'state_changed',
         (snapshot) => {
        // progress function ...
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        console.log(progress);
      },
        (error) => {
          // Error function ...
          setLoading(false);
          console.log(error);
        },
        () => {
          storage.ref('images').child(currentUser.id).getDownloadURL().then(url => {
            console.log(url);
            const updateUser = {
              photoURL: url,
              location: location,
              skills: skills,
              fName: firstName,
              lName: lastName
            }
            firestore.doc(`webUsers/${currentUser.id}`).update(updateUser)
              .then(() => {
                console.log('Profile Updated');
              }).catch(err => {
                console.log(err);
              }).finally(() => {
                history.push('/homepage');
              }
            )
          }).catch(err => {
            console.log(err);
          }
        
        )}

    )}
    
    

  return (

    <div  style={myStyle}>

<GreenHeader/>


<div className='sPPCont'>

    <h1>Let’s get you started! 🎉 </h1>

    <img src={pldp} alt="Image Placeholder"  className='imgSup'/>


      <form>

         <label className="selectImage">

              <div className='selectSpan'>

                  <AiOutlineCamera className='selectSvg' />
                      
                      <p>
                        Upload Profile Photo 
                      </p>
                          
                      <input
                            type="file"
                            name="uploadimage"
                            accept="image/*"
                            onChange={onImageChange}
                            className="upload-input"
                            required
                      />

              </div>
              
                
        </label> 

        </form>



<form>


<div className="sPPName">

  <input type="text" name='' placeholder={plfirstName}  onChange={(e) => setFirstName(e.target.value)} required className='firstName1' />
  <input type="text" name='' placeholder={pllastName} onChange={(e) => setLastName(e.target.value)} required className='lastName1' />

  </div>

  <div className='location'>
  <input type="text" name='' placeholder={pllocation} onChange={(e) => setLocation(e.target.value)}  className='Location' required />
  </div>

  <div className='occupation'>
  <input type="text" name='' placeholder={plskills} className='Location' onChange={(e) => setSkills(e.target.value)} required />
  <p> e.g Project Manager focused on social impact </p>

  {/* <li> <Link to="/addLinks"> Add Profile Url</Link></li>  */}

  </div>

  <div class="line-1"></div>

  <button className="nextBtn" onClick={updateProfile} >
   {isloading ? <Spinner animation="border" role="status" size="sm" variant="primary" /> : <p>Update Profile</p>}
  </button>



</form>

</div>




        
</div>
  )
}

export default SetupProfilePage 